module.exports = __webpack_public_path__ + "static/colegio_br-5f6df3275856524dda9dd7aaca8ac93f.png";